import { Pipe, PipeTransform } from '@angular/core';

import { WindowService } from './window.service';

@Pipe({
  name: 'htmlDecode',
})
export class HtmlDecodePipe implements PipeTransform {

  constructor(private win: WindowService) { }

  transform(text) {
    const div = this.win.nativeDocument.createElement('div');
    div.innerHTML = text;
    return div.innerHTML;
  }
}
